import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "overflow-hidden rounded-lg shadow-lg ring-1 ring-gray-300 text-sm bg-white" }
const _hoisted_2 = { class: "py-3" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = { class: "flex items-center gap-1" }
const _hoisted_7 = { class: "truncate font-medium" }
const _hoisted_8 = { class: "ml-6 break-words text-gray text-xs" }

import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { LockClosedIcon } from "@heroicons/vue/24/outline";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { ReportPlotType } from "@/types/Report";
import reportIconsConfig from "@/views/reports/components/reportIconsConfig";
import { usePlotTypes } from "@/views/reports/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddReportMenu',
  props: {
  position: {
    type: String,
    required: false,
  },
  width: {
    type: String,
    required: false,
  },
},
  emits: ["createReport"],
  setup(__props, { emit: __emit }) {

const plotTypes = usePlotTypes();



const emits = __emit;

const { t } = useI18n();

const sortedPlotTypes = computed(() =>
  plotTypes?.value ? [...plotTypes.value].sort((a, b) => a.type.localeCompare(b.type)) : [],
);

const createReport = (plotType: ReportPlotType, close: () => void) => {
  emits("createReport", plotType);
  close();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popover), { class: "relative flex items-center" }, {
    default: _withCtx(() => [
      _createVNode(_unref(PopoverButton), { class: "outline-none" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "icon")
        ]),
        _: 3
      }),
      _createVNode(_Transition, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "translate-y-1 opacity-0",
        "enter-to-class": "translate-y-0 opacity-100",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "translate-y-0 opacity-100",
        "leave-to-class": "translate-y-1 opacity-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(PopoverPanel), {
            class: _normalizeClass([__props.position, __props.width, 'absolute z-50 mt-3'])
          }, {
            default: _withCtx(({ close }) => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedPlotTypes.value, (plot) => {
                    return (_openBlock(), _createElementBlock("div", {
                      onClick: ($event: any) => (plot.enabled && createReport(plot?.type, close)),
                      key: plot.type
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                  plot.enabled ? 'hover:bg-gray-100 hover:cursor-pointer' : 'text-gray-700',
                  'flex flex-col px-4 py-1.5 w-full group',
                ])
                      }, [
                        _createElementVNode("div", _hoisted_4, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(reportIconsConfig)[plot.type].icon), {
                            class: _normalizeClass([_unref(reportIconsConfig)[plot.type].style, 'h-4 w-4 flex-shrink-0'])
                          }, null, 8, ["class"])),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)(`analytics.reports.${plot.type}_plot`)), 1),
                              (!plot.enabled)
                                ? (_openBlock(), _createBlock(_unref(LockClosedIcon), {
                                    key: 0,
                                    class: "h-4 w-4 ml-2"
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("small", _hoisted_8, _toDisplayString(_unref(t)(`analytics.reports.plot_descriptions.${plot.type}`)), 1)
                      ], 2)
                    ], 8, _hoisted_3))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})